var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 4.47716 4.47715 0 10 0H109C114.523 0 119 4.47715 119 10V114H0V10Z",
  fill: "#606AEA",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M91 55C91 72.6733 76.6733 87 59 87C41.3267 87 27 72.6733 27 55C27 37.3267 41.3267 23 59 23C76.6733 23 91 37.3267 91 55Z",
  fill: "#606AEA"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M70.9998 55L62.8435 54.98L54.686 54.96L58.9998 23H68.3448L70.9998 55Z",
  fill: "#FF69AB"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59 49.408V23H51V39H27V47H40.2611L59 49.408Z",
  fill: "#FFC7B8"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M71 55L62.8438 54.98V23H68.345L71 55Z",
  fill: "#DE5B95"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M70.9989 54.9205C71.0757 59.538 67.2612 63.1264 62.8438 62.9963C62.3988 62.9838 61.9475 62.9325 61.4938 62.8413L43 59.1175L41.6725 87H27V83L34.2038 79.265L34.8703 52.2595C34.9424 49.334 37.3347 47 40.2611 47H62.8228C67.2394 47 70.9254 50.5044 70.9989 54.9205Z",
  fill: "#FAB096"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M71 55.0575C71 59.6087 67.2175 63.125 62.8438 62.9963V47C67.2937 47 71 50.6075 71 55.0575Z",
  fill: "#E38B85"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M90.9998 47V67L86.9998 71V87H58.9998V76.8162C55.6286 75.0938 53.1161 72.1737 51.8711 68.7287L62.8436 65.4925L78.9998 60.7287V47L84.9998 43L90.9998 47Z",
  fill: "#DED6FA"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M91 47V67L87 71V87H62.8438V65.4925L79 60.7287V47L85 43L91 47Z",
  fill: "#BCB2DF"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M79 39H91V47H79V39Z",
  fill: "#DED6FA"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M79 60.7285V68.7285H51.8713C51.3038 67.156 51 65.4735 51 63.7448V60.7285H79Z",
  fill: "#F1F1FA"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M62.8438 60.7285H79V68.7285H62.8438V60.7285Z",
  fill: "#DED6FA"
});
function SvgSymptomDiarrhoea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomDiarrhoea);
export default __webpack_public_path__ + "static/media/symptom-Diarrhoea.ee619154f637c302cd8c0ecc99e7f287.svg";
export { ForwardRef as ReactComponent };